import { GetServerSidePropsResult } from 'next';
import qs from 'qs';

export const COLORS = [
  '#857040',
  '#C2AD7D',
  '#DDE7FC',
  '#8DADF5',
  '#497DEF',
  '#F1F1F1',
  '#C2AD7D',
  '#DDE7FC',
  '#8DADF5',
  '#497DEF',
];

export const notFound: GetServerSidePropsResult<any> = { notFound: true };

export const MIN_SHIPPING_POLICY_PRICE = 0;
export const REMOVE_SHIPPING_POLICY_PRICE = -99;

export const storageAccountName: any = process.env.NEXT_PUBLIC_STORAGE_ACCOUNT_NAME;

export const excludedBrands = [
  'moet',
  'krug',
  'hennessy',
  'hampden',
  'dom',
  'rignon',
  'domains chateau',
  'charles heidsieck',
  'gaja',
];

export const lastActivityType = {
  order: 'order',
  ask: 'ask',
  bid: 'bid',
};

export const defaultBackendDate = new Date('1970-01-01T12:21:00.000Z').getTime();
